import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=f1e2646c"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=f1e2646c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports